import React from "react";
import { ReactSVG } from "react-svg";

// assets
import { Alert } from "@assets/icons";

/** Libraries */
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Zoom,
  TransitionProps
} from "@libraries/mui";

/** Styled components */
import * as Styled from "./styles";

/** Interfaces */
export interface IPendency {
  contract?: string;
  client?: string;
  concreting?: string;
}

interface IProps {
  open: boolean;
  onClose: () => void;
  title: any;
  pendencies: IPendency;
}

/** Transition helper component */
const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
  ) => <Zoom ref={ref} {...props} />
);

/** Component */
const PendencyDialog: React.FC<IProps> = ({
  title,
  open,
  onClose,
  pendencies,
  children
}) => (
  <Styled.Container
    open={open}
    onClose={onClose}
    aria-labelledby="pendencyDialog-title"
    aria-describedby="pendencyDialog-description"
    TransitionComponent={Transition}
  >
    <DialogTitle id="pendencyDialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="pendencyDialog-description">
        {pendencies.client && (
          <Styled.Content>
            <Styled.ContentIcon>
              <ReactSVG src={Alert} />
            </Styled.ContentIcon>

            <Styled.ContentInfo>
              <Styled.ContentInfoTitle>
                Pendência no cliente:
              </Styled.ContentInfoTitle>
              {pendencies.client}
            </Styled.ContentInfo>
          </Styled.Content>
        )}
        {pendencies.contract && (
          <Styled.Content>
            <Styled.ContentIcon>
              <ReactSVG src={Alert} />
            </Styled.ContentIcon>

            <Styled.ContentInfo>
              <Styled.ContentInfoTitle>
                Pendência no contrato:
              </Styled.ContentInfoTitle>
              {pendencies.contract}
            </Styled.ContentInfo>
          </Styled.Content>
        )}
        {pendencies.concreting && (
          <Styled.Content>
            <Styled.ContentIcon>
              <ReactSVG src={Alert} />
            </Styled.ContentIcon>

            <Styled.ContentInfo>
              <Styled.ContentInfoTitle>
                Pendência na concretagem:
              </Styled.ContentInfoTitle>
              {pendencies.concreting}
            </Styled.ContentInfo>
          </Styled.Content>
        )}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Styled.DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </Styled.DialogActions>
    </DialogActions>
  </Styled.Container>
);

export default PendencyDialog;
